import { render, staticRenderFns } from "./coaching_board.vue?vue&type=template&id=4a08c690&scoped=true&"
import script from "./coaching_board.vue?vue&type=script&lang=js&"
export * from "./coaching_board.vue?vue&type=script&lang=js&"
import style0 from "./coaching_board.vue?vue&type=style&index=0&id=4a08c690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a08c690",
  null
  
)

export default component.exports